import {FormControlLabel, Grid, Switch, Typography} from "@mui/material";
import {StyledComponentProps} from '@mui/styles';
import React from "react";

interface Props extends StyledComponentProps {
    checked: boolean,
    onChange: () => unknown,
    children: string,
    labelPlacement?: 'end' | 'start' | 'top' | 'bottom',
}

export function Toggle(props: Props) {
    return (
            <Grid container justifyContent="center" alignItems="center" classes={props.classes}>
                <FormControlLabel
                        labelPlacement={props.labelPlacement}
                        control={<Switch checked={props.checked} onChange={props.onChange}/>}
                        label={<Typography align="center">{props.children}</Typography>}
                />
            </Grid>
    );
}
